import React from 'react';
import {
  Button,
  Heading,
  VStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { TbChevronDown } from 'react-icons/tb';

import { useReleaseNotes } from '../components/ReleaseNotesProvider';
import LoadingIndicator from './uiold/LoadingIndicator';
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Icon,
  MarkdownBlock,
} from '../core-ui';

export default function ReleaseNotesModal() {
  const { openState, latestRelease, hideReleaseNotes } = useReleaseNotes();
  const isOpen = openState !== 'CLOSED';

  const closeForever = () => {
    if (latestRelease) {
      localStorage.setItem('last-dismissed-release-notes', latestRelease.name);
    }
    hideReleaseNotes();
  };

  return (
    <Modal isOpen={isOpen} onClose={() => hideReleaseNotes()} size="3xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("What's new in this release")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {latestRelease == null ? (
            <LoadingIndicator />
          ) : (
            <VStack align="stretch">
              <Heading size="lg">{latestRelease.name}</Heading>
              <MarkdownBlock
                content={
                  latestRelease.notes.length > 0
                    ? latestRelease.notes
                    : t('No notes for this release')
                }
              />
              <DetailedNotes content={latestRelease.details} />
            </VStack>
          )}
        </ModalBody>

        <ModalFooter>
          {openState === 'AUTO_OPENED' && (
            <Button colorScheme="blue" mr={3} onClick={closeForever}>
              {t("Don't Show Again")}
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

function DetailedNotes(props: { content: string }) {
  const { content } = props;

  if (content.length === 0) {
    return null;
  }

  return (
    <Accordion allowToggle>
      <AccordionItem>
        <h2>
          <AccordionButton>
            <Box as="span" flex="1" textAlign="left">
              {t('View technical details')}
            </Box>
            <Icon as={TbChevronDown} fontSize={16} />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4}>
          <MarkdownBlock content={content} />
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
